import { FC, PropsWithChildren, createContext, useState } from "react";
import DocumentReference, {
  BoundingBox,
} from "../models/conversation/document";

type LegislationReferenceValueType = {
  selectedBoundingBoxes: BoundingBox[];
  setSelectedBoundingBoxes: (boundingBoxes: BoundingBox[]) => void;
  documentReferences: DocumentReference[];
  setDocumentReferences: (documentReferences: DocumentReference[]) => void;
};

const LegislationReferenceContext =
  createContext<LegislationReferenceValueType | null>(null);

const LegislationReferenceProvider: FC<PropsWithChildren> = ({
  children,
  ...props
}) => {
  /**** States ****/
  const [documentReferences, setDocumentReferences] = useState<
    DocumentReference[]
  >([]);
  const [selectedBoundingBoxes, setSelectedBoundingBoxes] = useState<
    BoundingBox[]
  >([
    {
      page: 3,
      x0: 42,
      y0: 72,
      x1: 555,
      y1: 810,
    },
  ]);
  return (
    <LegislationReferenceContext.Provider
      {...props}
      value={{
        selectedBoundingBoxes,
        setSelectedBoundingBoxes,
        documentReferences,
        setDocumentReferences,
      }}
    >
      {children}
    </LegislationReferenceContext.Provider>
  );
};

export default LegislationReferenceProvider;
